import React, { Component, Fragment } from 'react';
import { formValueSelector } from 'redux-form';
import { connect } from 'react-redux';
import moment from 'moment';
import PropTypes from 'prop-types';

import { Filter, Main } from 'Containers';
import { errorToast } from 'Common/ToastHelper';
import { ON_HAND_REPORT_TRANSACTION_DETAILS_FORM_NAME } from 'Common/FormEnum';
import { resetForm, submitForm } from 'State/forms/actions';
import { OnHandReportTransactionDetailsEnum } from 'Common/FieldEnum';
import { DATE_FORMAT_FOR_SERVER } from 'Common/Constants';
import { NotificationDialog } from 'Components';
import { GenericEnum } from 'Common/Constants/Enumeration/CommonEnum';
import { clearGridPreferenceSubmitError } from 'State/gridPreference/actions';
import { resetDirty } from 'State/dirtyTracking/actions';
import { clearTableSavedState } from 'Common/FormHelper';
import { TableNamesEnum } from 'Common/Constants/Enumeration/TableEnum';
import { setTableStates } from 'Common/UserSettings/state/actions';
import { getTableStates } from 'Common/UserSettings/helpers/helper';
import { ReportGeneration } from 'Common/ObjectHelper';
import * as GridPreferenceSelector from 'State/gridPreference/selectors';

import { TransactionDetailsReportContainer } from './TransactionDetailsReport';
import {
  clearReportError,
  getOnHandTransactionHistory,
} from '../../state/actions';
import {
  resetPrintResponse,
  printReportData,
  clearPrintReportError,
  getTxnTypes,
} from '../../../commonState/actions';
import { BASE_URL, INITIAL_VALUES } from '../../helper/transactionDetails';
import { PRINT_TRAN_DETAIL_URL } from '../../helper/onHand';
import * as CommonPrintSelector from '../../../commonState/selectors';
import * as OnHandTransactionReportSelector from '../../state/selectors';

class TransactionDetailsReport extends Component {
  static propTypes = {
    submitForm: PropTypes.func.isRequired,
    resetForm: PropTypes.func.isRequired,
    getOnHandTransactionHistory: PropTypes.func.isRequired,
    printReportData: PropTypes.func.isRequired,
    resetPrintResponse: PropTypes.func.isRequired,
    getTxnTypes: PropTypes.func.isRequired,
    clearReportError: PropTypes.func.isRequired,
    clearGridPreferenceSubmitError: PropTypes.func.isRequired,
    clearPrintReportError: PropTypes.func.isRequired,
    resetDirty: PropTypes.func.isRequired,
    setTableStates: PropTypes.func.isRequired,
    selectedFifoSitesItems: PropTypes.object.isRequired,
    onHandTransactionDetailsItems: PropTypes.array.isRequired,
    loadingOnHandTransactionDetailsItemsError: PropTypes.oneOfType([
      PropTypes.object,
      PropTypes.array,
    ]),
    loadingTransactionTypesDataError: PropTypes.oneOfType([
      PropTypes.object,
      PropTypes.array,
    ]),
    loadingTransactionTypesData: PropTypes.bool.isRequired,
    printLoading: PropTypes.bool.isRequired,
    allTableStates: PropTypes.object.isRequired,
    preferenceJsonError: PropTypes.oneOfType([
      PropTypes.object,
      PropTypes.array,
    ]),
    gridPreferenceSubmitError: PropTypes.oneOfType([
      PropTypes.object,
      PropTypes.array,
    ]),
    emptyPrintResponse: PropTypes.string,
    printError: PropTypes.object,
    printData: PropTypes.string,
    TypesValue: PropTypes.array,
  };
  
  static defaultProps = {
    preferenceJsonError: null,
    gridPreferenceSubmitError: null,
    emptyPrintResponse: '',
    printError: null,
    printData: '',
    TypesValue: [],
    loadingOnHandTransactionDetailsItemsError: null,
    loadingTransactionTypesDataError: null,
  };

  static path = `${BASE_URL}/transactiondetails`;
  state = {
    showNoDataModal: false,
  };

  handleSubmit = values => {
    const { selectedFifoSitesItems, TypesValue } = this.props;
    const input = {
      [OnHandReportTransactionDetailsEnum.ItemIds]:
        selectedFifoSitesItems[OnHandReportTransactionDetailsEnum.ItemIds],
      [OnHandReportTransactionDetailsEnum.SiteIds]:
        selectedFifoSitesItems[OnHandReportTransactionDetailsEnum.SiteIds],
      [OnHandReportTransactionDetailsEnum.ShowAllDates]: false,
      [OnHandReportTransactionDetailsEnum.FromDt]: moment(
        values[OnHandReportTransactionDetailsEnum.FromDt]
      ).format(DATE_FORMAT_FOR_SERVER),
      [OnHandReportTransactionDetailsEnum.ToDt]: moment(
        values[OnHandReportTransactionDetailsEnum.ToDt]
      ).format(DATE_FORMAT_FOR_SERVER),
      [OnHandReportTransactionDetailsEnum.Types]: TypesValue,
    };
    this.props.printReportData(PRINT_TRAN_DETAIL_URL, input);
  };

  handleClickPrint = () => {
    this.props.submitForm(ON_HAND_REPORT_TRANSACTION_DETAILS_FORM_NAME);
  };

  getMainProps = () => {
    const { printLoading } = this.props;
    return {
      toolbox: {
        backButtonProps: { shown: true, path: `${BASE_URL}` },
        rightButtons: [
          {
            content: 'Print',
            onClick: this.handleClickPrint,
            loading: printLoading,
          },
        ],
        shown: true,
      },
    };
  };

  componentDidMount() {
    const {
      getOnHandTransactionHistory,
      selectedFifoSitesItems,
      getTxnTypes,
    } = this.props;
    if (
      selectedFifoSitesItems &&
      selectedFifoSitesItems[OnHandReportTransactionDetailsEnum.ItemIds] &&
      selectedFifoSitesItems[OnHandReportTransactionDetailsEnum.ItemIds]
        .length &&
      selectedFifoSitesItems[OnHandReportTransactionDetailsEnum.SiteIds] &&
      selectedFifoSitesItems[OnHandReportTransactionDetailsEnum.SiteIds].length
    ) {
      const input = {
        [OnHandReportTransactionDetailsEnum.ShowAllDates]: false,
        [OnHandReportTransactionDetailsEnum.Types]:
          INITIAL_VALUES[OnHandReportTransactionDetailsEnum.Types],
        [OnHandReportTransactionDetailsEnum.FromDt]: moment(
          INITIAL_VALUES[OnHandReportTransactionDetailsEnum.FromDt]
        ).format(DATE_FORMAT_FOR_SERVER),
        [OnHandReportTransactionDetailsEnum.ToDt]: moment(
          INITIAL_VALUES[OnHandReportTransactionDetailsEnum.ToDt]
        ).format(DATE_FORMAT_FOR_SERVER),
        ...selectedFifoSitesItems,
      };
      getOnHandTransactionHistory(input);
      getTxnTypes();
    } else {
      this.props.history.push(BASE_URL);
    }
    this.props.resetDirty();
  }

  componentDidUpdate(prevProps) {
    const {
      clearReportError,
      clearGridPreferenceSubmitError,
      clearPrintReportError,
      printData,
    } = this.props;
    if (
      errorToast(
        this.props,
        prevProps,
        'loadingOnHandTransactionDetailsItemsError'
      ) ||
      errorToast(this.props, prevProps, 'preferenceJsonError') ||
      errorToast(this.props, prevProps, 'loadingTransactionTypesDataError') ||
      errorToast(this.props, prevProps, 'gridPreferenceSubmitError') ||
      errorToast(this.props, prevProps, 'printError')
    ) {
      clearReportError();
      clearGridPreferenceSubmitError();
      clearPrintReportError();
    }
    if (printData && printData !== prevProps.printData) {
      ReportGeneration(printData, 'On Hand Transaction Report');
      clearPrintReportError();
    }
  }

  componentWillUnmount() {
    this.clearTableSavedState();
  }

  clearTableSavedState = () => {
    const { history, allTableStates, setTableStates } = this.props;
    clearTableSavedState(history, BASE_URL, allTableStates, setTableStates, [
      TableNamesEnum.ON_HAND_REPORT_SITE_GRID_TABLE,
      TableNamesEnum.ON_HAND_REPORT_ITEM_GRID_TABLE,
      TableNamesEnum.ON_HAND_REPORT_FIFO_TABLE,
      TableNamesEnum.ON_HAND_REPORT_TRANSACTION_DETAILS_TABLE,
    ]);
  };

  clearFilter = () => {
    this.props.resetForm(ON_HAND_REPORT_TRANSACTION_DETAILS_FORM_NAME);
  };

  getBreadCrumbs = () => {
    return [
      {
        title: 'Reports | On Hand',
        link: `${BASE_URL}`,
      },
      {
        title: 'Transaction Details',
        link: '',
      },
    ];
  };
  handleNoDataDialog = () => {
    const { emptyPrintResponse, resetPrintResponse } = this.props;
    emptyPrintResponse === GenericEnum.EmptyString && resetPrintResponse();
  };

  render() {
    const { selectedFifoSitesItems, emptyPrintResponse } = this.props;
    return (
      <Fragment>
        <Filter
          title={''}
          breadcrumbs={this.getBreadCrumbs()}
          style={{
            width: 600,
          }}
        />
        <Main {...this.getMainProps()} shouldNotUsePageWidth>
          <TransactionDetailsReportContainer
            onSubmit={this.handleSubmit}
            initialValues={{
              ...INITIAL_VALUES,
              ...selectedFifoSitesItems,
            }}
          />
        </Main>
        <NotificationDialog
          title={'Print Report'}
          showDialog={emptyPrintResponse === GenericEnum.EmptyString}
          message={'No data available.'}
          onOkClick={this.handleNoDataDialog}
        />
      </Fragment>
    );
  }
}

const selector = formValueSelector(
  ON_HAND_REPORT_TRANSACTION_DETAILS_FORM_NAME
);
const mapStateToProps = state => {
  return {
    selectedFifoSitesItems: OnHandTransactionReportSelector.getSelectedFifoSitesItems(
      state
    ),
    onHandTransactionDetailsItems: OnHandTransactionReportSelector.getOnHandTransactionDetailsItems(
      state
    ),
    loadingOnHandTransactionDetailsItemsError: OnHandTransactionReportSelector.getLoadingOnHandTransactionDetailsItemsError(
      state
    ),

    preferenceJsonError: GridPreferenceSelector.getPreferenceJsonError(state),
    gridPreferenceSubmitError: GridPreferenceSelector.getSubmitError(state),
    emptyPrintResponse: CommonPrintSelector.getEmptyPrintResponse(state),
    loadingTransactionTypesDataError: CommonPrintSelector.getLoadingTransactionTypesDataError(
      state
    ),
    loadingTransactionTypesData: CommonPrintSelector.getLoadingTransactionTypesData(
      state
    ),
    printLoading: CommonPrintSelector.getPrintLoading(state),
    printError: CommonPrintSelector.getPrintError(state),
    printData: CommonPrintSelector.getPrintData(state),
    allTableStates: getTableStates(state),
    TypesValue: selector(state, OnHandReportTransactionDetailsEnum.Types),
  };
};

const mapDispatchToProps = {
  submitForm,
  resetForm,
  getOnHandTransactionHistory,
  printReportData,
  resetPrintResponse,
  getTxnTypes,
  clearReportError,
  clearGridPreferenceSubmitError,
  clearPrintReportError,
  resetDirty,
  setTableStates,
};

export const TransactionDetailsReports = connect(
  mapStateToProps,
  mapDispatchToProps
)(TransactionDetailsReport);



// WEBPACK FOOTER //
// ./src/pages/reports/inventory/onhandreport/containers/transactiondetails/TransactionDetailsReportContainer.js